import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { data, globalData } from '../../models/notificationData';
import style from './index.module.less';
import xlsxSvg from './assets/xlsx.svg';
import zipSvg from './assets/zip.svg';
import pdfSvg from './assets/pdf.svg';
import { DownloadOutlined } from '@ant-design/icons';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '@/models/store';
import { useTranslation } from '@/hooks/useTranslation';

function getFileTypeSvg(type: string) {
  switch (type) {
    case 'xlsx':
      return xlsxSvg;
    case 'zip':
      return zipSvg;
    case 'pdf':
      return pdfSvg;
    default:
      return '';
  }
}

export default () => {
  const $ = useTranslation();
  const { noticeId } = useParams<{ noticeId: string }>();
  const isGlobal = useSelector<RootState>(state => state.LocaleModel.isGlobal, shallowEqual);

  const dataSource = useMemo(
    () => (isGlobal ? globalData : data).find(item => item.id === Number(noticeId)) || null,
    [noticeId, isGlobal]
  );

  return (
    <div className={style.container}>
      <div className={style.title}>{dataSource?.title}</div>
      <div className={style.time}>{dataSource?.time}</div>
      <div className={style.line} />
      <div
        className={style.content}
        dangerouslySetInnerHTML={{ __html: dataSource?.content ?? '' }}
      />
      {dataSource?.assets && dataSource.assets.length > 0 && (
        <>
          <div className={style.subtitle}>{$('附件')}</div>
          <div className={style.assets}>
            {dataSource.assets.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className={style['assets-item']}>
                <span className={style['assets-item-bd']}>
                  <img
                    src={getFileTypeSvg(item.type)}
                    alt={item.name}
                    className={style['assets-item-icon']}
                  />
                  <a href={item.url} target='_blank' className={style['assets-item-name']}>
                    {item.name}
                  </a>
                  <DownloadOutlined
                    style={{ fontSize: '16px', color: '#0068FF', cursor: 'pointer' }}
                    onClick={() => {
                      window.open(item.url, '_blank');
                    }}
                  />
                </span>
                {item.date && <span className={style['assets-item-date']}>{item.date}</span>}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
